import { requestJson } from "@/lib/api";

const BASE = "api/v1/admin/supplier-invoices/collector";

/** Configuração da coleta automática POR INTERVALO (habilitação PRÓPRIA, separada das flags do botão manual). */
export interface CollectorConfig {
  enabled: boolean;
  intervalMinutes: number; // intervalo da coleta automática (padrão 90)
  maxLotes: number;
  maxDurationMinutes: number;
  lotesCeiling: number;
}

export interface CollectorConfigUpdate {
  enabled: boolean;
  intervalMinutes: number;
  maxLotes: number;
  maxDurationMinutes: number;
  lotesCeiling: number;
}

/** Estado do agendamento por intervalo: última/próxima execução, execução ativa e eventual bloqueio. */
export interface CollectorSchedule {
  enabled: boolean;
  intervalMinutes: number;
  lastRunAt: string | null;
  nextRunAt: string | null;
  hasActiveRun: boolean;
  lastFinishReason: string | null;
}

/** Uma execução da coleta (automática ou extraordinária). */
export interface CollectorRun {
  id: string;
  establishmentId: string;
  tpAmb: number;
  trigger: "AUTO" | "ADMIN";
  serviceDate: string | null;
  status: "RUNNING" | "COMPLETED" | "STOPPED" | "FAILED";
  startedAt: string;
  finishedAt: string | null;
  lotesDone: number;
  docsTotal: number;
  xmlsTotal: number;
  resumosTotal: number;
  errorsTotal: number;
  lastOutcome: string | null;
  lastUltNsu: string | null;
  stopRequested: boolean;
  finishReason: string | null;
  heartbeatAt: string | null;
}

export async function getCollectorConfig(): Promise<CollectorConfig> {
  return requestJson<CollectorConfig>(`${BASE}/config`);
}

export async function updateCollectorConfig(req: CollectorConfigUpdate): Promise<CollectorConfig> {
  return requestJson<CollectorConfig>(`${BASE}/config`, { method: "PUT", body: req });
}

export async function getCollectorSchedule(): Promise<CollectorSchedule> {
  return requestJson<CollectorSchedule>(`${BASE}/schedule`);
}

/** Dispara uma coleta EXTRAORDINÁRIA (assíncrona). Retorna o id da execução. 409 se já houver ativa. */
export async function runCollector(establishmentId: string): Promise<{ runId: string }> {
  return requestJson<{ runId: string }>(
    `${BASE}/run?establishmentId=${encodeURIComponent(establishmentId)}`, { method: "POST" });
}

export async function stopCollectorRun(runId: string): Promise<CollectorRun> {
  return requestJson<CollectorRun>(`${BASE}/runs/${encodeURIComponent(runId)}/stop`, { method: "POST" });
}

export async function getCollectorRun(runId: string): Promise<CollectorRun> {
  return requestJson<CollectorRun>(`${BASE}/runs/${encodeURIComponent(runId)}`);
}

export async function getCollectorHistory(limit = 30): Promise<CollectorRun[]> {
  return requestJson<CollectorRun[]>(`${BASE}/runs?limit=${limit}`);
}
